export var GLOBAL = {
//url:'http://www.puertaldelcielo.site/API1102019/public/index.php/',
  //url:'http://lamparadelava.esy.es/API/public/index.php/',
  //  url:'http://www.funerariadev.skn1.com/API/public/index.php/',
  //url:'http://www.funerariaapi.com/',
  //url:'http://www.localhost/api/public/index.php/',
  //url:'https://api-tepic.funeralespuertadelcielo.com/public/index.php',
  //url:'https://tepic.funeralespuertadelcielo.com/api/public/index.php/',
  url:'http://138.197.194.6/api/public/index.php/',
  levelaccess:{},
  sessionInfo:{"login":false}
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/global.ts